module.exports = __webpack_public_path__ + "static/media/tmpShoe.dfab8a86.png";